const CONSTANTS = {
    URLS: {
        KALTURA_IMPORTS: {
            EXPRESS_RECORDER: 'https://www.kaltura.com/apps/expressrecorder/latest/express-recorder.js',
            EMBED_PLAYER: (partner_id, uiconf_id) => `https://cdnapisec.kaltura.com/p/${partner_id}/sp/${partner_id}00/embedIframeJs/uiconf_id/${uiconf_id}/partner_id/${partner_id}`
        }
    }
}

export default CONSTANTS